import { fetchSeatTypes } from "@/api/modules/seattypes";

class SeatTypeModel {
    constructor(seatType) {
        this.id = seatType.id;
        this.dsb = Boolean(seatType.dsb);
        this.serviceLevel = seatType.serviceLevel;
        this.nameSingular = {
            da: seatType.danishNameSingular,
            en: seatType.englishNameSingular,
            de: seatType.germanNameSingular
        };
        this.namePlural = {
            da: seatType.danishNamePlural,
            en: seatType.englishNamePlural,
            de: seatType.germanNamePlural
        };
    }
}

export const state = {
    types: []
};

export const mutations = {
    setTypes: (state, payload) => {
        state.types = payload.map(seatType => {
            return new SeatTypeModel(seatType);
        });
    }
};

export const getters = {
    getTypeById: state => id => state.types.find(t => t.id === id),
    getTypeByIds: state => ids => state.types.filter(t => ids.includes(t.id))
};

export const actions = {
    fetchSeatTypes: async context => {
        const response = await fetchSeatTypes();
        if (!response.ok)
            throw new Error(JSON.stringify(response.responseBody));

        context.commit("setTypes", [
            ...response.responseBody.dsbSeatTypes.map(t => ({
                ...t,
                dsb: true
            })),
            ...response.responseBody.seatTicketTypes
        ]);

        return context.state.seatTypes;
    }
};
